/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'
import { useEffect, useState } from 'react'
import Player from 'react-player'
import WistiaPlayer from 'react-player/wistia'
import type {
	TextWithVideoFieldsFragment,
	FullWidthVideoFieldsFragment,
} from 'types/dato'
import s from './style.module.css'

const Video = ({
	url,
}: {
	url:
		| TextWithVideoFieldsFragment['videoUrl']
		| FullWidthVideoFieldsFragment['videoUrl']
}) => {
	const playerProps = {
		controls: true,
		url,
		width: '100%',
		height: '100%',
	}

	const [hasWindow, setHasWindow] = useState(false)

	useEffect(() => {
		if (typeof window !== 'undefined') {
			setHasWindow(true)
		}
	}, [])

	return (
		<div className={s.video}>
			<div className={s.videoInner}>
				{hasWindow ? (
					<>
						{url.includes('wistia') ? (
							<WistiaPlayer
								{...playerProps}
								config={{
									options: {
										controlsVisibleOnLoad: false,
									},
								}}
							/>
						) : (
							<Player {...playerProps} />
						)}
					</>
				) : null}
			</div>
		</div>
	)
}

export default Video
